export const checkContentSize = (content) => {
    const blob = new Blob([content]);
    const targetSize = 8 * 1024 * 1024;
    if (blob.size > targetSize) {
        return false;
    }
    return true;
};
